import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Table } from 'reactstrap';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import { Body, Header, TableActions, TablePagination } from './components/';
import { perPageOptions } from './utils';
import DataTableContext from '../../context/DataTableContext';
import AdvancedFilter from "../AdvancedFilter/AdvancedFilter";

export const DataTable = (props) => {
  const {
    customTableSetup,
    headers, 
    datasource, 
    onRowClick, 
    onRowClickCondition, 
    pageActions, 
    showAdvancedFilter, 
    updateDatasource 
  } = props;
  const { search } = useLocation();
  const urlParams = qs.parse(search);
  const [searchTerms, setSearchTerms] = useState(urlParams.quickFilter ? urlParams.quickFilter : '');
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [perPage, setPerPage] = useState(urlParams.pageSize || perPageOptions[2]);
  const [currentPage, setCurrentPage] = useState(datasource.currentPage || 1);

  const toggleSelectAll = () => {
    setSelectAllChecked(!selectAllChecked);
  };

  const setPageSize = (pageSize) => {
    setPerPage(pageSize);
    updateDatasource({ pageSize });
  };

  const setQuickFilter = (quickFilter) => {
    setSearchTerms(quickFilter);
    updateDatasource({ quickFilter });
  };

  const values = {
    currentPage,
    datasource,
    onRowClick,
    onRowClickCondition,
    perPage,
    perPageOptions,
    searchTerms,
    selectAllChecked,
    setCurrentPage,
    setPageSize,
    setQuickFilter,
    toggleSelectAll,
    updateDatasource
  };

  const advancedFilterHeaders = () => {
    return headers.filter(h => h.dataType).map(h => {
      return {
        label: h.text,
        value: h.key,
        type: h.dataType
      };
    });
  };

  const bodyData = datasource.data ? datasource.data.map(ds => ds.attributes) : [];

  return (
    <DataTableContext.Provider value={values}>
      <div id="datatable">
        <TableActions actions={pageActions} />
        {showAdvancedFilter && <AdvancedFilter columns={advancedFilterHeaders()} />}
        <Row>
          <Col xs="12">
            <Table hover>
              <Header headers={headers} customTableSetup={customTableSetup} />
              <Body headers={headers} datasource={bodyData} customTableSetup={customTableSetup} />
            </Table>
          </Col>
        </Row>
        <TablePagination
          currentPage={datasource.currentPage || 1}
          datasourceSize={datasource.resultSize || 0}
          pageSize={datasource.pageSize || 20}
          totalElements={datasource.totalElements || 0} />
      </div>
    </DataTableContext.Provider>
  );
};

DataTable.propTypes = {
  datasource: PropTypes.object.isRequired,
  headers: PropTypes.array.isRequired,
  onRowClick: PropTypes.func,
  onRowClickCondition: PropTypes.func,
  pageActions: PropTypes.shape({
    component: PropTypes.func.isRequired,
    actions: PropTypes.array
  }),
  showAdvancedFilter: PropTypes.bool.isRequired,
  updateDatasource: PropTypes.func.isRequired,
  customTableSetup : PropTypes.object.isRequired
};
